
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'

@Component({
  components: {}
})

export default class TenantUserEditDetailsTab extends Vue {
  settings = {
    routeNames: { show: 'tenantUserShow', edit: 'tenantUserEdit' },
    routeParamKey: 'tenantUserId',
    functionNames: { setCurrent: 'setCurrentTenantUser', clearCurrent: 'clearCurrentTenantUser', save: 'saveTenantUser' },
    getterNames: { current: 'currentTenantUser', loading: 'loadingTenantUser', errors: 'tenantUserErrors' }
  }

  newPassword = false

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
